module.exports = __webpack_public_path__ + "img/TD.c52e75ee.png";